import { faCalendarDays, faListOl, faUsers } from '@fortawesome/pro-light-svg-icons';
import clsx from 'clsx';
import { useAbandonedBookings } from 'components/Bookings2/Abandoned/AbandonedBookingsProvider';
import styles from 'components/Bookings2/Abandoned/Header/Actions/AbandonedBookingsHeaderActions.module.scss';
import { AbandonedBookingsAddButton } from 'components/Bookings2/Abandoned/Header/Actions/AddButton/AbandonedBookingsAddButton';
import OrganizationMarketplacesFilter from 'components/Bookings2/List/OrganizationMarketplacesFilter';
import { CalendarFilter } from 'components/UI';
import { SelectDropdown } from 'components/UI/V2/SelectDropdown/SelectDropdown';
import { stepFilterBuckets } from 'model/OnlineBooking';
import React from 'react';

const stepOptions = stepFilterBuckets.map(bucket => ({
    id: bucket.id,
    label: bucket.label
}));

interface AbandonedBookingsHeaderActionsProps {
    className?: string;
}

export const AbandonedBookingsHeaderActions: React.FC<AbandonedBookingsHeaderActionsProps> = ({ className }) => {
    const {
        selectedSteps,
        setSelectedSteps,
        clientFilterOptions,
        selectedClientFilters,
        setSelectedClientFilters,
        datePeriod,
        setDatePeriod,
        marketplaceIds,
        setMarketplaceIds
    } = useAbandonedBookings();

    return (
        <div className={clsx(styles.root, className)}>
            <OrganizationMarketplacesFilter
                selected={marketplaceIds}
                onChangeSelection={setMarketplaceIds}
            />

            <SelectDropdown
                multiple
                label="Steps"
                value={selectedSteps}
                options={stepOptions}
                buttonProps={{
                    size: 'large',
                    variant: 'outlined',
                    leftIcon: faListOl,
                    rightIcon: undefined,
                    hideLabelOnMobile: true,
                    className: styles.actionButton
                }}
                onChange={steps => setSelectedSteps(steps.map(step => step as string))}
            />

            <SelectDropdown
                multiple
                label="Clients"
                value={selectedClientFilters}
                options={clientFilterOptions.map(option => ({
                    id: option.id,
                    label: option.name
                }))}
                buttonProps={{
                    size: 'large',
                    variant: 'outlined',
                    leftIcon: faUsers,
                    rightIcon: undefined,
                    hideLabelOnMobile: true,
                    className: styles.actionButton
                }}
                onChange={clients => setSelectedClientFilters(clients.map(client => client as string))}
            />

            <CalendarFilter
                hideUpcoming
                hideTomorrow
                hideNext7Days
                optionSelected="Today"
                period={datePeriod}
                buttonIcon={faCalendarDays}
                className={styles.datePicker}
                onChange={setDatePeriod}
            />

            <AbandonedBookingsAddButton className={clsx(styles.onlyDesktop, styles.actionButton)} />
        </div>
    );
};
